import type { LabelInValue } from 'models';
import { Form, FormActions, Input, Modal, message } from 'ui';
import { useInviteUsersMutation } from '../../../queries';
import { UsersInput } from '../users-input';

type MembersInviteFormValues = {
  communityId: string;
  users: string[];
};

type P = {
  community?: LabelInValue;
  isOpened: boolean;
  onCancel: () => void;
};

const MembersInviteModal = ({ community, isOpened, onCancel }: P) => {
  const { isPending: isInvitingUsers, mutate: inviteUsers } = useInviteUsersMutation();

  const onFinish = (data: MembersInviteFormValues) => {
    inviteUsers(
      {
        id: data.communityId,
        invitees: {
          emails: [],
          phones: [],
          userIds: data.users,
        },
      },
      {
        onSuccess() {
          message.success('Invitations sent successfully');
          onCancel();
        },
      },
    );
  };

  const initialValues = {
    communityId: community?.value,
  };

  return (
    <Modal isOpened={isOpened} onCancel={onCancel} title="Select members to invite">
      <Modal.HugContent>
        <Form<MembersInviteFormValues> initialValues={initialValues} onFinish={onFinish}>
          <Form.Item<MembersInviteFormValues> hidden name="communityId" rules={[{ required: true }]}>
            <Input />
          </Form.Item>

          <Form.Item<MembersInviteFormValues> dependencies={['communityId']} noStyle>
            {({ getFieldsValue }) => {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
              const { communityId } = getFieldsValue(true) as Partial<MembersInviteFormValues>;

              return communityId ? (
                <Form.Item<MembersInviteFormValues> label="Members" name="users" rules={[{ required: true }]}>
                  <UsersInput autoClearSearchValue communityId={communityId} showDetailedOption />
                </Form.Item>
              ) : null;
            }}
          </Form.Item>

          <Modal.HugContent.Footer>
            <FormActions
              right={{
                children: 'Back',
                onClick() {
                  onCancel();
                },
              }}
              submit={{
                children: 'Send invitations',
                loading: isInvitingUsers,
              }}
            />
          </Modal.HugContent.Footer>
        </Form>
      </Modal.HugContent>
    </Modal>
  );
};

export default MembersInviteModal;
